import { Component, Input, OnInit, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { Resource } from '@shared/resource/models';
import { Service } from '@shared/service/models';
import { Location } from '@shared/location/models';
import { IParty } from '@tablesready/common-ui';
import { DateService, PartiesService } from '../../../services';
import { DetailModalActions } from '../day-grid-view/interfaces';
import { PartyActions } from '../../enums';
import { FrontendModalService } from '@tablesready/frontend-modal';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-detail-party',
  templateUrl: './detail-party.component.html',
  styleUrls: ['./detail-party.component.scss'],
})
export class DetailPartyComponent implements OnInit, OnDestroy {
  @Input() party: IParty;
  @Input() resources: Resource[];
  @Input() services: Service[];
  @Input() showActions: DetailModalActions;
  @Input() timezone: string;
  @Input() user: Location;
  @Input() isRestaurantOnFreePlan: boolean;

  icon = AppIcon;
  iconSize = AppIconSize;
  color = AppIconColor;
  partyTitle = '';
  chatBtnFocus = false;

  constructor(
    private readonly modalController: FrontendModalService,
    private readonly dateService: DateService,
    private readonly partiesService: PartiesService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) { }

  ngOnInit(): void {
    this.setPartyTitle();

    this.document.addEventListener('keydown', this.keyDownListener);
    this.document.addEventListener('mousedown', this.mouseDownListener);
  }

  setPartyTitle(): void {
    this.partyTitle = this.party?.name || '';
  }

  markCanceled(): void {
    this.modalController.dismiss({ eventType: PartyActions.confirmDelete });
  }

  editParty(): void {
    this.modalController.dismiss({ eventType: PartyActions.addEditReservation });
  }

  chatParty(): void {
    this.modalController.dismiss({ eventType: PartyActions.chatParty });
  }

  cancel(): void {
    this.modalController.dismiss({ eventType: PartyActions.cancel });
  }

  msToTime(ms): string {
    const time = this.dateService.convertTimestampToHour([ms], this.timezone);
    const { hours, minutes, meridiem } = time[0];

    return `${hours}:${minutes} ${meridiem.toLowerCase()}`;
  }

  checkIn(): void {
    this.modalController.dismiss({ eventType: PartyActions.checkIn });
  }

  serveParty(): void {
    this.modalController.dismiss({ eventType: PartyActions.serveParty });
  }

  completeParty(): void {
    this.modalController.dismiss({ eventType: PartyActions.completeParty });
  }

  showCheckInButton(party: IParty): boolean {
    return this.partiesService.showCheckInButton(party);
  }

  showServeButton(party: IParty): boolean {
    return !!party.checkin_time && !party.seated_time;
  }

  showCompleteButton(party: IParty): boolean {
    return !!party.seated_time && !!party.checkin_time;
  }

  ngOnDestroy(): void {
    this.document.removeEventListener('keydown', this.keyDownListener);
    this.document.removeEventListener('mousedown', this.mouseDownListener);
  }

  private readonly keyDownListener = (mouseEvent): void => {
    if (mouseEvent?.key === 'Escape') {
      this.cancel();
    }
  };

  private readonly mouseDownListener = (mouseEvent): void => {
    const className = String(mouseEvent?.target?.className);
    if (className?.includes('close-modal')) {
      this.cancel();
    }
  };
}
